export function plainLabelText(value) {
  const unwrapped = value && typeof value === "object" && "value" in value ? value.value : value;
  if (typeof unwrapped === "string") {
    return unwrapped.trim();
  }
  if (unwrapped && typeof unwrapped === "object" && typeof unwrapped.body_text === "string") {
    return unwrapped.body_text.trim();
  }
  return "";
}
